<template>
<div id="app" class="panel panel-primary">
    <div class="panel panel-heading">
    <h2>BMI Calculator</h2>
    </div>
        <div v-bind:class="bmiAlertClass">
        BMI {{ calculatedBMI }}
    </div>
    <div class="panel-body">
      <div class="col-sm-3 col-md-3">
        <div class="panel panel-heading panel-primary">
          <h2>Height</h2>
          <div class="panel panel-body">
          <label class="span1">Meters</label>
          <input v-model="heightInMeters" placeholder="Height M" @keyup="onHeightChange" class="form-control">
          <label class="span1">Feet</label>
          <input v-model="heightInFeet" placeholder="Height F" @keyup="updateHeightFromImperial" class="form-control">
          <label class="span1">Inch</label>
          <input v-model="heightInInch" placeholder="Height I"  @keyup="updateHeightFromImperial" class="form-control">
          </div>
      </div>
      </div>
      <div class="col-sm-3 col-md-3">
        <div class="panel panel-heading panel-primary">
          <h2>Weight</h2>
          <div class="panel panel-body">
          <label class="span1">Kg</label>
          <input v-model="weightInKg" placeholder="Weight KG" @keyup="onWeightChange" class="form-control">
          <label class="span1">Stone</label>
          <input v-model="weightInStone" placeholder="Weight S" @keyup="updateWeightFromImperial" class="form-control">
          <label class="span1">Lbs</label>
          <input v-model="weightInPounds" placeholder="Weight L" @keyup="updateWeightFromImperial" class="form-control">
          </div>
      </div>
      </div>
    </div>
</div>

</template>

<script>
export default {
  name: 'test',
  data () {
    return {
      bmiValue: 10,
      message: 'abcdefghi',
      heightInMeters: 0,
      weightInKg: 0,
      heightInFeet: 0,
      heightInInch: 0,
      weightInStone: 0,
      weightInPounds: 0
    }
  },
  computed: {
    calculatedBMI: function () {
      return (this.weightInKg / (this.heightInMeters * this.heightInMeters))
    },
    bmiAlertClass: function () {
      if (this.calculatedBMI < 20) {
        return 'alert alert-warning'
      } else if (this.calculatedBMI > 30) {
        return 'alert alert-danger'
      } else if (this.calculatedBMI > 25) {
        return 'alert alert-warning'
      } else {
        return 'alert alert-success'
      }
    }
  },
  methods: {
    updateBMI: function () {
      this.bmiValue = this.weightInKg / (this.heightInMeters * this.heightInMeters)
    },
    onWeightChange: function () {
      this.WeightMetricToImperial()
      this.updateBMI()
    },
    onHeightChange: function () {
      this.HeightMetricToImperial()
      this.updateBMI()
    },
    updateHeightFromImperial: function () {
      var feet = this.heightInFeet
      var inch = this.heightInInch
      var meters = (feet / 3.2808)
      meters = meters + (inch / 39.370)
      this.heightInMeters = meters.toFixed(2)
      this.updateBMI()
    },
    updateWeightFromImperial: function () {
      var stone = this.weightInStone
      var lbs = this.weightInPounds
      var kg = (stone / 0.15747)
      kg = kg + (lbs / 2.2046)
      this.weightInKg = kg.toFixed(2)
      this.updateBMI()
    },
    WeightMetricToImperial () {
      var x = Math.round(this.weightInKg * 2.2046226)
      this.weightInStone = Math.floor(x / 14)
      this.weightInPounds = x % 14
    },
    HeightMetricToImperial () {
      var inchs = Math.floor((this.heightInMeters / 0.0254))
      var feet = Math.floor(inchs / 12)
      var inch = Math.ceil(inchs - (feet * 12))
      this.heightInFeet = feet
      this.heightInInch = inch
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Test.vue